var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "line-item line-item-free-gift" }, [
    _c("img", {
      staticClass: "line-item-image",
      attrs: { src: _vm.sizedImageSrc, alt: _vm.imageAlt }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "line-item-text" }, [
      _c("h4", { staticClass: "line-item-title" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      _c("span", { staticClass: "line-item-subtitle" }, [
        _vm._v(_vm._s(_vm.subtitle))
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "line-item-cta" }, [_vm._v("\n    FREE GIFT\n  ")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }